import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "./index";

/**
 * Sends a virtual pageview on every route change. Mounted once in main.tsx, inside
 * <BrowserRouter> but outside <App> — outside so it keeps tracking through every auth state
 * (signed out, choosing a username, signed in), not just once the dashboard renders.
 *
 * Renders nothing; it exists purely for the effect.
 */
export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    analytics.page(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  return null;
}
